// actions
import * as actions from './actions';

const initialState = {
  error: null,
  id: null,
  createdAt: null,
  updatedAt: null,
  totalPrice: null,
  address: null,
  shippingPrice: null,
  user: null,
  initial: false,
  loading: false,
  cartItems: [],
  shipping: null,
  discountValue: 0,
  discountCode: null,
  wrongCouponFlag: false,

};

export default function cartReducer(state = initialState, action) {
  switch (action.type) {
    // FETCH
    case actions.FETCH_USER_CART.REQUEST:
    case actions.UPDATE_CART_ITEM.REQUEST:
    case actions.REMOVE_CART_ITEM.REQUEST:
    case actions.ADD_CART_ITEM.REQUEST:
    case actions.SET_DELIVERY_ADDRESS.REQUEST:
      return { ...state, loading: true };

    case actions.FETCH_USER_CART.SUCCESS:
    case actions.SET_DELIVERY_ADDRESS.SUCCESS:
    case actions.SET_SHIPPING_TYPE.SUCCESS: {
      const cart = action.payload.results[0]
      const id = cart.id;
      const createdAt = cart.created_at;
      const updatedAt = cart.updated_at;
      const totalPrice = cart.total_price;
      const address = cart.address;
      const shippingPrice = cart.shipping_price;
      const cartItems = cart.cart_items;
      const discountValue = cart.discount_value
      const discountCode = cart.discount_code

      return { ...state, initial: true, loading: false, id, createdAt, updatedAt, totalPrice, address, shippingPrice, cartItems, discountValue, discountCode };
    }

    // case actions.SET_DELIVERY_ADDRESS.SUCCESS:
    //   return { ...state, initial: true, loading: false, ...action.payload.results[0] };

    // case actions.SET_SHIPPING_TYPE.SUCCESS:
    //   return { ...state, initial: true, loading: false, ...action.payload.results[0] };

    case actions.FETCH_USER_CART_ITEMS.SUCCESS:
      return { ...state, initial: true, loading: false, cartItems: action.payload.cartItems };


    case actions.ADD_CART_ITEM.SUCCESS:
      return { ...state, initial: true, loading: false, cartItems: action.payload.cartItems };

    case actions.FETCH_USER_CART.FAILURE:
      return { ...state, initial: false, loading: false, error: action.payload.error };

    // UPDATE
    case actions.UPDATE_CART_ITEM.SUCCESS:
      return { ...state, loading: false, cartItems: action.payload.cartItems };

    case actions.UPDATE_CART_ITEM.FAILURE:
      return { ...state, initial: false, loading: false, error: action.payload.error };

    // REMOVE
    case actions.REMOVE_CART_ITEM.SUCCESS:
      return { ...state, initial: false, loading: false, cartItems: action.payload.cartItems };

    case actions.REMOVE_CART_ITEM.FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    case actions.APPLY_DISCOUNT.SUCCESS: {
      const response = action.payload;
      if (response.valid_coupon) {
        return { ...state, initial: true, loading: false, discountValue: response.discount_value, discountCode: response.discount_code };

      }

      return { ...state, loading: false, error: action.payload.error, wrongCouponFlag: true };
    }



    // REMOVEs
    default:
      return state;
  }
};